import { applyConsent } from "@/lib/analytics";

export const COOKIE_CONSENT_KEY = "techtail_cookie_consent";
export const COOKIE_PREFS_EVENT = "techtail:open-cookie-preferences";
export const COOKIE_CONSENT_UPDATED_EVENT = "techtail:consent-updated";

export type CookieCategory = "necessary" | "analytics" | "marketing";

export type CookieConsent = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  timestamp: string;
};

export const defaultConsent: CookieConsent = {
  necessary: true,
  analytics: false,
  marketing: false,
  timestamp: "",
};

export const getConsent = (): CookieConsent | null => {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Migrate legacy shape { accepted: boolean }
    if (typeof parsed?.accepted === "boolean") {
      return {
        necessary: true,
        analytics: parsed.accepted,
        marketing: parsed.accepted,
        timestamp: parsed.timestamp ?? new Date().toISOString(),
      };
    }
    return {
      necessary: true,
      analytics: Boolean(parsed?.analytics),
      marketing: Boolean(parsed?.marketing),
      timestamp: parsed?.timestamp ?? new Date().toISOString(),
    };
  } catch {
    return null;
  }
};

export const saveConsent = (consent: Omit<CookieConsent, "necessary" | "timestamp">) => {
  const value: CookieConsent = {
    necessary: true,
    analytics: consent.analytics,
    marketing: consent.marketing,
    timestamp: new Date().toISOString(),
  };
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(value));
  } catch {
    /* storage unavailable */
  }
  applyConsent(value);
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_UPDATED_EVENT, { detail: value }));
  return value;
};

export const openCookiePreferences = () => {
  window.dispatchEvent(new CustomEvent(COOKIE_PREFS_EVENT));
};

/** Call once at startup: sets Consent Mode defaults and loads GTM only if consent exists. */
export const initConsent = () => {
  applyConsent(getConsent());
};
